import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoubleCheckmark2Small"><Path d="M15.9111 7.90625L15.2529 8.6582L7.54883 17.4629L3.08594 13L4.5 11.5859L7.45117 14.5371L13.7471 7.3418L14.4062 6.58887L15.9111 7.90625ZM20.9111 7.90625L20.2529 8.6582L13.2529 16.6582L12.5938 17.4111L11.0889 16.0938L11.7471 15.3418L18.7471 7.3418L19.4062 6.58887L20.9111 7.90625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark2Small;
